import React, { useState, useEffect } from 'react';
import { FormGroup, Label } from 'reactstrap';
import Select from 'react-select';
import useSelect from '../hooks/useSelect';
import childService from '../services/childService';
import familyService from '../services/familyService';
import Required from '../components/Required';
import ListItemGuardian from '../components/ListItemGuardian';
import classroomService from '../services/classroomService';
import userService from '../services/userService';

export default function FamilyToClassroomForm(props) {
  const {
    setSelectedClassroomId, setSelectedChildId, setSelectedFamilyId,
    classroomError, familiesError, childError,
  } = props;

  const [classrooms, setClassrooms] = useState([]);
  const [children, setChildren] = useState([]);
  const [families, setFamilies] = useState([]);

  const [usersToSendTo, setUsersToSendTo] = useState([]);

  const {
    value: selectedClassroom,
    bind: bindSelectedClassroom,
    setValue: setSelectedClassroom,
  } = useSelect();

  const {
    value: selectedChild,
    bind: bindSelectedChild,
    setValue: setSelectedChild,
  } = useSelect();

  const {
    value: selectedFamily,
    bind: bindSelectedFamily,
    setValue: setSelectedFamily,
  } = useSelect();

  useEffect(() => {
    familyService
      .getFamilies(false)
      .then((r) => {
        const mappedFamilies = r.model.map((c) => ({
          value: c.familyId,
          label: c.name,
        }));
        setFamilies(mappedFamilies);

        if (r.model.length === 1) {
          setSelectedFamily(mappedFamilies[0]);
        }
      });
  }, []);

  useEffect(() => {
    setSelectedChild(undefined);
    setSelectedFamilyId(undefined);

    if (selectedFamily) {
      setSelectedFamilyId(selectedFamily.value);

      childService
        .findForFamily(selectedFamily.value)
        .then((r) => {
          const mappedChildren = r.model.map((c) => ({
            value: c.childId,
            label: c.fullName,
          }));

          setChildren(mappedChildren);

          if (r.model.length === 1) {
            setSelectedChild(mappedChildren[0]);
          }
        });
    }
  }, [selectedFamily]);

  useEffect(() => {
    setSelectedChildId(undefined);
    setSelectedClassroom(undefined);

    if (selectedChild) {
      setSelectedChildId(selectedChild.value);

      classroomService
        .findForChild(selectedChild.value)
        .then((r) => {
          if (!r.hasError) {
            const mappedClassrooms = r.model.map((c) => ({
              value: c.classroomId,
              label: c.name,
            }));

            setClassrooms(mappedClassrooms);

            if (r.model.length === 1) {
              setSelectedClassroom(mappedClassrooms[0]);
            }
          }
        });
    }
  }, [selectedChild]);

  useEffect(() => {
    setSelectedClassroomId(undefined);

    if (selectedClassroom) {
      setSelectedClassroomId(selectedClassroom.value);

      userService
        .getCaregiversForClassroom(selectedClassroom.value).then((r) => {
          setUsersToSendTo(r.model);
        });
    } else {
      setUsersToSendTo(undefined);
    }
  }, [selectedClassroom]);

  return (
    <>
      {families.length > 1
      && (
        <FormGroup>
          <Label>
            Family&nbsp;
            <Required />
          </Label>
          <Select
            className={familiesError ? 'tf-select hasError' : 'tf-select'}
            {...bindSelectedFamily}
            options={families}
          />
        </FormGroup>
      )}

      {children.length > 0
      && (
        <FormGroup>
          <Label>
            In regards to&nbsp;
            <Required />
          </Label>
          <Select
            className={childError ? 'tf-select hasError' : 'tf-select'}
            {...bindSelectedChild}
            options={children}
          />
        </FormGroup>
      )}

      {classrooms.length > 1
      && (
        <FormGroup>
          <Label>
            Classroom&nbsp;
            <Required />
          </Label>
          <Select
            className={classroomError ? 'tf-select hasError' : 'tf-select'}
            {...bindSelectedClassroom}
            options={classrooms}
          />
        </FormGroup>
      )}

      {usersToSendTo && usersToSendTo.length > 0 && (
        <div className="bg-light">
          <Label className="mb-3">
            The following Caregivers/Providers will be able to view and respond to your message:
          </Label>
          {usersToSendTo.map((g) => (
            <ListItemGuardian canEdit={false} key={g.id} guardian={g} />
          ))}
        </div>
      )}
    </>
  );
}
